
import PricingButton from "@/components/main/pricing/PricingButton";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import SearchCircle from "@/components/main/core/SearchCircle"

import data from "@/mixins/data";
import isMobile from "@/mixins/isMob";
export default {
  name: "TinderTab",
  components: { PricingButton, RedHeadBox, SearchCircle },
  mixins: [data, isMobile],
  data() {
    return {
      date: new Date(),
    }
  },
  methods: {
    datenow() {
      if (this.date.getMinutes())
        return `${this.date.getMonth() + 1}/${this.date.getDate()}/${this.date.getFullYear()} ${this.date.getHours()}:${+this.date.getMinutes() <= 10 ? '0' + this.date.getMinutes() : this.date.getMinutes()}`
    },
  }
  }
